@if (mapItem(); as mapItem) {
    <ui-popup-view-container>
        <ui-detail-image
            [imagePath]="mapItem.thumbnailPath"
            [altText]="mapItem.title"
        />

        <ui-detail-content>
            <ui-detail-section>
                <ui-detail-title [title]="mapItem.title"/>

                <ui-detail-address [text]="mapItem.address"/>
            </ui-detail-section>

            <ui-detail-tags
                [tags]="mapItem.tags"
            />
        </ui-detail-content>
    </ui-popup-view-container>
}
